



















































































import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import LoadingMixin from '../../../mixins/loading'
import { PluginMixin } from '../../../mixins/plugin'

import { TagsService } from '../../../services/api/tags'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'

import { log } from '../../../log'

const catalogTagProperty = (() => {
  const base = 'mycolor.mailmagazine.smbrand.micoameri'
  const title = '2018AW'

  return {
    base,
    title,
    fullpath: `${base}.${title}`,
  }
})()

@Component({
  components: {
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class CatalogRegister extends Mixins<PluginMixin>(PluginMixin) {
  followStatus: boolean = false

  loading: boolean = false
  modalMessage: string = ''
  showModal: boolean = false
  nextOnError: string | null = null

  tagsService = new TagsService()

  get isLoading() {
    return this.loading
  }

  get alreadyRegistered() {
    return this.followStatus
  }

  get hasEnoughUserInfo() {
    return this.$store.getters['user/hasMinimumNecessaryProfileForPurchase']
  }

  get canRegister() {
    return this.hasEnoughUserInfo && !this.alreadyRegistered
  }

  get buttonMode() {
    return this.canRegister  ? 'primary--large' : 'disabled--large'
  }
  get buttonType() {
    return this.canRegister  ? 'submit' : 'button'
  }

  get errorOnLoad() {
    return _.get(this.$store.state.user, 'error.load')
  }

  async created() {
    await this.initialize()
  }

  async onSubmit() {
    this.loading = true

    const errorMessage = 'カタログ応募に失敗しました。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'

    try {
      const pathname = catalogTagProperty.fullpath
      const parameter = {
        follow: true,
      }

      const response = await this.tagsService.put(pathname, parameter)

      if (response.isLeft()) {
        log.error({ page: '/s/mypage/caralog-register', error: response.value })
        this.showModal = true
        this.modalMessage = errorMessage

        return
      }

      await this.initialize()
    } catch (error) {
      log.error({ page: '/s/mypage/caralog-register', error })
      this.showModal = true
      this.modalMessage = errorMessage

    } finally {
      this.loading = false
    }
  }

  onCloseErrorModal() {
    this.showModal = false

    if (this.nextOnError !== null) {
      this.$router.push(this.nextOnError)
    }
  }

  private async initialize() {
    this.loading = true

    // Load User
    const [tags] = await Promise.all([
      this.tagsService.getAsUser(catalogTagProperty.base, {
        with: 'follow',
      }),
      // 配送先情報を参照するため、ユーザー情報も取得
      this.$store.dispatch('user/get', { force: true }),
    ])

    if (tags.isLeft()) {
      this.modalMessage = 'カタログ応募情報が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true
      this.nextOnError = '/mypage'
      this.loading = false

      return
    }
    this.followStatus = this.extractCatalogRegistrationState(tags.value)

    // other
    if (this.errorOnLoad) {
      this.modalMessage = 'お客様情報が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true
      this.loading = false

      return
    }
    this.loading = false
  }

  private extractCatalogRegistrationState(tags: any): boolean {
    const catalogTag = _.find(tags, t => t.pathname === catalogTagProperty.fullpath)

    if (catalogTag === null) {
      return false
    }

    return _.get(catalogTag, 'follow', false)
  }
}
